import { render } from "./Event-Details.vue?vue&type=template&id=3ec06e76&scoped=true"
import script from "./Event-Details.vue?vue&type=script&lang=js"
export * from "./Event-Details.vue?vue&type=script&lang=js"

import "./Event-Details.vue?vue&type=style&index=0&id=3ec06e76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ec06e76"

export default script